import React from 'react';
import {
  RideFiConfettiLight,
  RideFiPendingSoatLight,
  RideFiNotificationsLight,
  RideGlSoatSolid,
  RideGlInformationSolid,
  RideGlDocumentSolid,
  RideGlStarSolid,
  RideGlFileSolid,
  RideGlPremiumHealthSolid,
  RideGlWheelchairSolid,
  RideGlHospitalSolid,
  RideFiSendInfoLight,
  RideFiErrorLight,
  RideIcGasolineLight,
  RideIcBatteryLight,
  RideIcTowTruckLight
} from '@rimac-seguros/ride-system-components';

const ICONS = {
  RideFiConfettiLight,
  RideFiPendingSoatLight,
  RideFiNotificationsLight,
  RideGlSoatSolid,
  RideGlInformationSolid,
  RideGlDocumentSolid,
  RideGlStarSolid,
  RideGlFileSolid,
  RideGlPremiumHealthSolid,
  RideGlWheelchairSolid,
  RideGlHospitalSolid,
  RideFiSendInfoLight,
  RideFiErrorLight,
  RideIcGasolineLight,
  RideIcBatteryLight,
  RideIcTowTruckLight
};

const DynamicIcon = ({ icon, size = 'medium', className }) => {
  const IconComponent = ICONS[icon];
  return IconComponent ? <IconComponent size={size} className={className} /> : null;
};

export default DynamicIcon;
